import mutations from './mutations'
import getters from './getters'
import actions from './actions'

export default {
  namespaced: true,
  state () {
    return {
      questions: [],
      actionPlan: {},
      actionPlans: [],
      singleActionPlan: {}
    }
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
